
import { faEllipsisVertical } from '@fortawesome/pro-regular-svg-icons'
import { Divider, styled } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-premium'

import { Dropdown } from '../../Dropdown/Dropdown'
import { DropdownItem } from '../../Dropdown/DropdownItem'
import { Icon } from '../../Icon/Icon'
import { GridRowActions } from '../models/GridRowActions'

export type RowActionsGridCellProps = GridRenderCellParams & {
  //
}

export const RowActionsGridCell: React.FC<RowActionsGridCellProps> = ({ row, id }) => {
  const { rowActions } = row


  return row.hasActions ? (
    <StyledCell key={id}>
      {rowActions && rowActions.length > 0 && <Dropdown
        icon={<StyledActionIcon icon={faEllipsisVertical} />}
        value="Actions"
        isIconButton
        slotProps={{
          popper: {
            placement: 'right-start',
          },
          iconButton: {
            round: false,
            sx: {
              margin: 0,
            },
          },
        }}
      >
        {(rowActions as GridRowActions).map((actionItem, index) => {
          if (actionItem.type === 'action' || !actionItem.type) {
            const { label, icon, uiColor, disabled, onClick } = actionItem

            return (
              <DropdownItem
                key={index}
                onSelect={() => {
                  onClick(row)
                  // apiRef.current.selectRows([id], true)
                }}
                disabled={disabled}
              >
                {icon && <Icon sx={{ color: uiColor }} icon={icon} />}
                {label}
              </DropdownItem>
            )
          }

          if (actionItem.type === 'divider') {
            return (
              <li key={index}>
                <Divider />
              </li>
            )
          }
        })}
      </Dropdown>}
    </StyledCell>
  ) : null
}

const StyledCell = styled('div')`
  color: ${({ theme }) => theme.palette.text.primary};
  background-color: transparent;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const StyledActionIcon = styled(Icon)`
  font-size: ${props => props.theme.typography.pxToRem(16)};
  width: ${props => props.theme.typography.pxToRem(16)};
  height: ${props => props.theme.typography.pxToRem(16)};
  transform: none !important;
`